module.exports = __webpack_public_path__ + "img/drifter-zone-qr-code-frame.860f1b2.png";